/* ============================================================================
   19 · Newsroom — the blog's articles, as Shopify's `blog` object would hand
   them to the template (blog.articles, newest first).
   Source: wearfigs.com/pages/newsroom, read 2026-11-02 — the lead story, the
   3-up row and the "carousel" archive, 31 articles. Images are each tile's
   wearfigs.com Contentful asset at 880w (the lead story's is its mobile hero,
   the collage the Figma card uses), saved under assets/articles/.
   `url` is the live article page; on Shopify it becomes article.url
   (/blogs/newsroom/<handle>).
   Rebuild: python3 -I scripts/pull-newsroom.py (from this folder).
   ========================================================================== */

export const BLOG = {
  handle: 'newsroom',
  title: 'Newsroom',
  url: '/blogs/newsroom',
  pressEmail: 'press@wearfigs.com',
  /* paginate blog.articles by 12 — the Figma frame's four rows of three */
  perPage: 12,
};

export const ARTICLES = [
  {
    "handle": "people-sma-102926",
    "title": "Medicine Is Sexy: FIGS and PEOPLE Team Up for 2026’s “Sexiest Man Alive” Issue",
    "published_at": "2026-10-30",
    "url": "https://www.wearfigs.com/pages/newsroom-people-sma-102926",
    "image": {
      "src": "assets/articles/people-sma-102926.webp",
      "alt": "Medicine Is Sexy: FIGS and PEOPLE Team Up for 2026’s “Sexiest Man Alive” Issue",
      "width": 750,
      "height": 1050
    },
    "excerpt": "<em>The Pitt </em>star and Global FIGS Ambassador Noah Wylie gets the official title—and FIGS releases graphic tees celebrating his real-world counterparts."
  },
  {
    "handle": "puffer-relaunch-102726",
    "title": "FIGS introduces new packable puffers for lightweight warmth on the go",
    "published_at": "2026-10-27",
    "url": "https://www.wearfigs.com/pages/newsroom-puffer-relaunch-102726",
    "image": {
      "src": "assets/articles/puffer-relaunch-102726.webp",
      "alt": "FIGS introduces new packable puffers for lightweight warmth on the go",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "fibrex-fall-drop-102026",
    "title": "FIGS Launches Best-Selling Espresso and Dark Açaí in FIBREx™",
    "published_at": "2026-10-20",
    "url": "https://www.wearfigs.com/pages/newsroom-fibrex-fall-drop-102026",
    "image": {
      "src": "assets/articles/fibrex-fall-drop-102026.webp",
      "alt": "FIGS Launches Best-Selling Espresso and Dark Açaí in FIBREx™",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "oog-101526",
    "title": "Introducing OOG: An All-in-One Continuing Education Platform for Healthcare Professionals",
    "published_at": "2026-10-15",
    "url": "https://www.wearfigs.com/pages/newsroom-oog-101526",
    "image": {
      "src": "assets/articles/oog-101526.webp",
      "alt": "Introducing OOG: An All-in-One Continuing Education Platform for Healthcare Professionals",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "kids-scrubs-101526",
    "title": "FIGS Debuts Kids’ Scrubwear Collection for Halloween",
    "published_at": "2026-10-13",
    "url": "https://www.wearfigs.com/pages/newsroom-kids-scrubs-101526",
    "image": {
      "src": "assets/articles/kids-scrubs-101526.webp",
      "alt": "FIGS Debuts Kids’ Scrubwear Collection for Halloween",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "fall-drop-100626",
    "title": "F(all) of It: Iconic Espresso, Plus New Dark Açaí and Best-Selling Bonsai",
    "published_at": "2026-10-06",
    "url": "https://www.wearfigs.com/pages/newsroom-fall-drop-100626",
    "image": {
      "src": "assets/articles/fall-drop-100626.webp",
      "alt": "F(all) of It: Iconic Espresso, Plus New Dark Açaí and Best-Selling Bonsai",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "bca-092426",
    "title": "FIGS Brings Back Fight Club Pink and F’ing Pink",
    "published_at": "2026-09-24",
    "url": "https://www.wearfigs.com/pages/newsroom-bca-092426",
    "image": {
      "src": "assets/articles/bca-092426.webp",
      "alt": "FIGS Brings Back Fight Club Pink and F’ing Pink",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "berry-spice-martini-olive-091026",
    "title": "Happy Hours: NEW Berry Spice and Best-Selling Martini Olive",
    "published_at": "2026-09-10",
    "url": "https://www.wearfigs.com/pages/newsroom-berry-spice-martini-olive-091026",
    "image": {
      "src": "assets/articles/berry-spice-martini-olive-091026.webp",
      "alt": "Happy Hours: NEW Berry Spice and Best-Selling Martini Olive",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "sagewater-smokey-taupe-082526",
    "title": "Ready, Reset, Go: FIGS Launches Summer-to-Fall Collection",
    "published_at": "2026-08-25",
    "url": "https://www.wearfigs.com/pages/newsroom-sagewater-smokey-taupe-082526",
    "image": {
      "src": "assets/articles/sagewater-smokey-taupe-082526.webp",
      "alt": "Ready, Reset, Go: FIGS Launches Summer-to-Fall Collection",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "fibrex-081826",
    "title": "FIGS Launches Nine New Styles with New FIBREx™",
    "published_at": "2026-08-18",
    "url": "https://www.wearfigs.com/pages/newsroom-fibrex-081826",
    "image": {
      "src": "assets/articles/fibrex-081826.webp",
      "alt": "FIGS Launches Nine New Styles with New FIBREx™",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "back-to-school-080526",
    "title": "FIGS Launches Back-to-School Campaign With Fresh Styles and Colors",
    "published_at": "2026-08-05",
    "url": "https://www.wearfigs.com/pages/newsroom-back-to-school-080526",
    "image": {
      "src": "assets/articles/back-to-school-080526.webp",
      "alt": "FIGS Launches Back-to-School Campaign With Fresh Styles and Colors",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "v-coterie-080326",
    "title": "FIGS Acquires V Coterie and Launches Medical-Inspired Jewelry Collection",
    "published_at": "2026-08-03",
    "url": "https://www.wearfigs.com/pages/newsroom-v-coterie-080326",
    "image": {
      "src": "assets/articles/v-coterie-080326.webp",
      "alt": "FIGS Acquires V Coterie and Launches Medical-Inspired Jewelry Collection",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "espresso-072826",
    "title": "A Surprise Drop of Buzzy Espresso in Best-Selling Styles",
    "published_at": "2026-07-28",
    "url": "https://www.wearfigs.com/pages/newsroom-espresso-072826",
    "image": {
      "src": "assets/articles/espresso-072826.webp",
      "alt": "A Surprise Drop of Buzzy Espresso in Best-Selling Styles",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "spider-man-072126",
    "title": "FIGS and Marvel Launch Exclusive Spider-Man Collection",
    "published_at": "2026-07-21",
    "url": "https://www.wearfigs.com/pages/newsroom-spider-man-072126",
    "image": {
      "src": "assets/articles/spider-man-072126.webp",
      "alt": "FIGS and Marvel Launch Exclusive Spider-Man Collection",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "celery-deep-purple-070726",
    "title": "FIGS Launches FlexKnit in New Celery and Best-Selling Deep Purple",
    "published_at": "2026-07-07",
    "url": "https://www.wearfigs.com/pages/newsroom-celery-deep-purple-070726",
    "image": {
      "src": "assets/articles/celery-deep-purple-070726.webp",
      "alt": "FIGS Launches FlexKnit in New Celery and Best-Selling Deep Purple",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "new-waistbands-070126",
    "title": "Best-Selling Scrub Pants Launch With New Ruched Waistbands",
    "published_at": "2026-07-01",
    "url": "https://www.wearfigs.com/pages/newsroom-new-waistbands-070126",
    "image": {
      "src": "assets/articles/new-waistbands-070126.webp",
      "alt": "Best-Selling Scrub Pants Launch With New Ruched Waistbands",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "optic-white-amethyst-061626",
    "title": "FIGS Brings Back Best-Selling Optic White and Amethyst",
    "published_at": "2026-06-16",
    "url": "https://www.wearfigs.com/pages/newsroom-optic-white-amethyst-061626",
    "image": {
      "src": "assets/articles/optic-white-amethyst-061626.webp",
      "alt": "FIGS Brings Back Best-Selling Optic White and Amethyst",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "archtek-060926",
    "title": "First-Ever Patented Medical-Grade Compression Socks",
    "published_at": "2026-06-09",
    "url": "https://www.wearfigs.com/pages/newsroom-archtek-060926",
    "image": {
      "src": "assets/articles/archtek-060926.webp",
      "alt": "First-Ever Patented Medical-Grade Compression Socks",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "seaglass-sea-mist-060226",
    "title": "FIGS Brings Back Best-Selling Colors Seaglass and Sea Mist",
    "published_at": "2026-06-02",
    "url": "https://www.wearfigs.com/pages/newsroom-seaglass-sea-mist-060226",
    "image": {
      "src": "assets/articles/seaglass-sea-mist-060226.webp",
      "alt": "FIGS Brings Back Best-Selling Colors Seaglass and Sea Mist",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "purple-haze-fireside-051926",
    "title": "FIGS Launches New Purple Haze and Brings Back Much-Loved Fireside",
    "published_at": "2026-05-19",
    "url": "https://www.wearfigs.com/pages/newsroom-purple-haze-fireside-051926",
    "image": {
      "src": "assets/articles/purple-haze-fireside-051926.webp",
      "alt": "FIGS Launches New Purple Haze and Brings Back Much-Loved Fireside",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "awesome-humans-on-the-hill-051726",
    "title": "FIGS and Noah Wyle Advocate in DC for Vital Legislation",
    "published_at": "2026-05-17",
    "url": "https://www.wearfigs.com/pages/newsroom-awesome-humans-on-the-hill-051726",
    "image": {
      "src": "assets/articles/awesome-humans-on-the-hill-051726.webp",
      "alt": "FIGS and Noah Wyle Advocate in DC for Vital Legislation",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "nurses-week-050626",
    "title": "Never Change: Free Pizza and Fresh Colorways for Nurses Week",
    "published_at": "2026-05-04",
    "url": "https://www.wearfigs.com/pages/newsroom-nurses-week-050626",
    "image": {
      "src": "assets/articles/nurses-week-050626.webp",
      "alt": "Never Change: Free Pizza and Fresh Colorways for Nurses Week",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "star-wars-043026",
    "title": "FIGS and Marvel Partner to Launch Exclusive STAR WARS™ Collection",
    "published_at": "2026-04-30",
    "url": "https://www.wearfigs.com/pages/newsroom-star-wars-043026",
    "image": {
      "src": "assets/articles/star-wars-043026.webp",
      "alt": "FIGS and Marvel Partner to Launch Exclusive STAR WARS™ Collection",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "maternity-scrubs-041426",
    "title": "FIGS Celebrates Moms-to-Be With New Maternity Collection",
    "published_at": "2026-04-14",
    "url": "https://www.wearfigs.com/pages/newsroom-maternity-scrubs-041426",
    "image": {
      "src": "assets/articles/maternity-scrubs-041426.webp",
      "alt": "FIGS Celebrates Moms-to-Be With New Maternity Collection",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "spring-drop-040726",
    "title": "New Sunrise Pink and Much-Loved Forest Green—In Full Bloom",
    "published_at": "2026-04-07",
    "url": "https://www.wearfigs.com/pages/newsroom-spring-drop-040726",
    "image": {
      "src": "assets/articles/spring-drop-040726.webp",
      "alt": "New Sunrise Pink and Much-Loved Forest Green—In Full Bloom",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "international-womens-day-030326",
    "title": "FIGS Launches New Colors for International Women's Day",
    "published_at": "2026-03-03",
    "url": "https://www.wearfigs.com/pages/newsroom-international-womens-day-030326",
    "image": {
      "src": "assets/articles/international-womens-day-030326.webp",
      "alt": "FIGS Launches New Colors for International Women's Day",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "deep-reef-lagoon-022426",
    "title": "FIGS Makes Waves With New Lagoon and Best-Selling Deep Reef",
    "published_at": "2026-02-24",
    "url": "https://www.wearfigs.com/pages/newsroom-deep-reef-lagoon-022426",
    "image": {
      "src": "assets/articles/deep-reef-lagoon-022426.webp",
      "alt": "FIGS Makes Waves With New Lagoon and Best-Selling Deep Reef",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "crop-wide-leg-021726",
    "title": "BFFs Forever: FIGS Drops Cropped Scrub Tops and Wide-Leg Scrub Pants",
    "published_at": "2026-02-17",
    "url": "https://www.wearfigs.com/pages/newsroom-crop-wide-leg-021726",
    "image": {
      "src": "assets/articles/crop-wide-leg-021726.webp",
      "alt": "BFFs Forever: FIGS Drops Cropped Scrub Tops and Wide-Leg Scrub Pants",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "olympics-012726",
    "title": "FIGS Launches 2026 Olympics Campaign Featuring Lindsey Vonn and Her Medical Team",
    "published_at": "2026-01-27",
    "url": "https://www.wearfigs.com/pages/newsroom-olympics-012726",
    "image": {
      "src": "assets/articles/olympics-012726.webp",
      "alt": "FIGS Launches 2026 Olympics Campaign Featuring Lindsey Vonn and Her Medical Team",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "valentines-day-011326",
    "title": "Love, Actually: New Pulmonary Pink for Valentine's Day",
    "published_at": "2026-01-13",
    "url": "https://www.wearfigs.com/pages/newsroom-valentines-day-011326",
    "image": {
      "src": "assets/articles/valentines-day-011326.webp",
      "alt": "Love, Actually: New Pulmonary Pink for Valentine's Day",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  },
  {
    "handle": "new-uniform-010626",
    "title": "FIGS Launches Fresh Styles for the New Year",
    "published_at": "2026-01-01",
    "url": "https://www.wearfigs.com/pages/newsroom-new-uniform-010626",
    "image": {
      "src": "assets/articles/new-uniform-010626.webp",
      "alt": "FIGS Launches Fresh Styles for the New Year",
      "width": 880,
      "height": 1075
    },
    "excerpt": ""
  }
];
